import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '../../../Context';
import DeviationDuperbrowseContext from '../../../Duperbrowse/DeviationDuperbrowseContext';
import { BiLoggerContextProvider } from '../../../biLogger';
import { sliceToDivisible } from '../../helpers';
import DeviationSidebarTorpedo from '../DeviationSidebarTorpedo';
import ThumbWithLoader from '../ThumbWithLoader';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import s from './DeviationSidebarGrid.sidebar_9_thumbs.scss';
var thumbHeight = parseInt(s['sidebar-thumb-height']);
var thumbWidth = parseInt(s['sidebar-thumb-width']);
var ITEMS_PER_ROW = 3;
export var DeviationSidebarGrid = function (_a) {
    var streamId = _a.streamId, deviations = _a.deviations, parentDeviation = _a.parentDeviation, title = _a.title, className = _a.className, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.maxRows, maxRows = _c === void 0 ? 3 : _c;
    var isMobile = useContext(MobileContext);
    var maxItems = maxRows * ITEMS_PER_ROW;
    if (isMobile) {
        return (React.createElement(DeviationSidebarTorpedo, { streamId: streamId, parentDeviation: parentDeviation, deviations: deviations, title: title, className: className }));
    }
    var slice = isLoading
        ? Array(maxItems).fill(undefined)
        : sliceToDivisible(deviations, ITEMS_PER_ROW, maxItems);
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(DeviationDuperbrowseContext, { streamId: streamId, deviations: deviations, parent: {
                title: title || 'deviation',
                typeId: getDeviationResourceType(parentDeviation),
                itemId: parentDeviation.deviationId,
            } }, slice.map(function (deviation, index) { return (React.createElement(BiLoggerContextProvider, { key: index, value: { _rankIndex: index } },
            React.createElement(ThumbWithLoader, { deviation: deviation, isLoading: isLoading, className: s['grid-item'], width: thumbWidth, height: thumbHeight, greenLikeCrop: true }))); }))));
};
export default DeviationSidebarGrid;
//# sourceMappingURL=DeviationSidebarGrid.sidebar_9_thumbs.js.map